// @ts-nocheck

import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, FileText, MousePointer, Send } from "lucide-react";
import CommunicationLogsTab from "./CommunicationLogsTab";
import CommunicationAnalyticsTab from "./CommunicationAnalyticsTab";
import CommunicationClicksTab from "./CommunicationClicksTab";
import { EmailSendingPanel } from "./EmailSendingPanel";

const CommunicationAnalyticsModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState("analytics");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Communication Analytics</h1>
          <p className="text-muted-foreground">
            View analytics and logs for all communication activities
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="analytics" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Analytics
          </TabsTrigger>
          <TabsTrigger value="sending" className="flex items-center gap-2">
            <Send className="h-4 w-4" />
            Email Queue
          </TabsTrigger>
          <TabsTrigger value="clicks" className="flex items-center gap-2">
            <MousePointer className="h-4 w-4" />
            Clicks & Track-throughs
          </TabsTrigger>
          <TabsTrigger value="logs" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Logs
          </TabsTrigger>
        </TabsList>

        <TabsContent value="analytics" className="space-y-4">
          <CommunicationAnalyticsTab />
        </TabsContent>

        <TabsContent value="sending" className="space-y-4">
          <EmailSendingPanel />
        </TabsContent>

        <TabsContent value="clicks" className="space-y-4">
          <CommunicationClicksTab />
        </TabsContent>

        <TabsContent value="logs" className="space-y-4">
          <CommunicationLogsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CommunicationAnalyticsModule;
